import { defaultHttpClient } from '../../httpClient';
import type { GetGoodsReviewsResponse } from './types';

/**
 * - 상품 리뷰 목록 조회 API
 */
export const getGoodsReviews = (goodsSno: number) => {
  return defaultHttpClient
    .request<GetGoodsReviewsResponse>({
      method: 'GET',
      url: `/webview/goods/${goodsSno}/reviews/`,
    })
    .then(result => result.data);
};